import React from 'react';

const videoWrapperStyle = { padding: '56.25% 0 0 0', position: 'relative' };

const topRowVideos = [
  {
    id: 'mercedes',
    src: 'https://player.vimeo.com/video/1008128487?badge=0&autopause=0&player_id=0&app_id=58479',
    title: 'MERCEDES',
    allow: 'autoplay; fullscreen; picture-in-picture; clipboard-write',
  },
  {
    id: 'nicolas',
    src: 'https://player.vimeo.com/video/1008119035?badge=0&autopause=0&player_id=0&app_id=58479',
    title: 'NICOLAS',
    allow: 'autoplay; fullscreen; picture-in-picture; clipboard-write',
  },
];

const bottomRowVideos = [
  {
    id: 'jonny',
    src: 'https://player.vimeo.com/video/1008128415?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
    title: 'Jonny',
    allow: 'autoplay; fullscreen; picture-in-picture; clipboard-write',
  },
  {
    id: 'testimonial-2',
    src: 'https://player.vimeo.com/video/1008128547?badge=0&autopause=0&player_id=0&app_id=58479/embed',
    title: 'Testimonial Video 2',
    allow: 'autoplay; fullscreen; picture-in-picture',
    allowFullScreen: true,
  },
  {
    id: 'neddy',
    src: 'https://player.vimeo.com/video/826732395?h=625fea9c18&badge=0&autopause=0&player_id=0&app_id=58479',
    title: 'NEDDY',
    allow: 'autoplay; fullscreen; picture-in-picture',
    allowFullScreen: true,
  },
];

const TestimonialsSection = () => (
  <section className="testimonials-section">
    <div className="header">
      <h2>What Our Students Say?</h2>
      <p>Hear from people who attended our events and transformed their real estate knowledge</p>
    </div>

    <div className="content">
      <div className="video-grid">
        <div className="top-row">
          {topRowVideos.map((video) => (
            <div className="video-card" key={video.id}>
              <div className="video-embed">
                <div style={videoWrapperStyle}>
                  <iframe
                    src={video.src}
                    allow={video.allow}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    title={video.title}
                  ></iframe>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bottom-row">
          {bottomRowVideos.map((video) => (
            <div className="video-card" key={video.id}>
              <div className="video-embed">
                <div style={videoWrapperStyle}>
                  <iframe
                    src={video.src}
                    allow={video.allow}
                    allowFullScreen={video.allowFullScreen}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    title={video.title}
                  ></iframe>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
